/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AlbumResponse } from '../../models/album-response';
import { CreateAlbumDto } from '../../models/create-album-dto';

export interface AlbumsControllerCreate$Params {
      body: CreateAlbumDto
}

export function albumsControllerCreate(http: HttpClient, rootUrl: string, params: AlbumsControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<AlbumResponse>> {
  const rb = new RequestBuilder(rootUrl, albumsControllerCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AlbumResponse>;
    })
  );
}

albumsControllerCreate.PATH = '/albums/admin';
